import React from 'react';
import { values } from '../../data/site';
export function About() {
  return <section id="om" className="scroll-mt-24 border-y border-line bg-canvas-deep" data-id="element-204" data-mp="or48z8g6lnzz">
      <div className="mx-auto max-w-content px-5 py-16 md:py-24 lg:px-8" data-id="element-205" data-mp="oti39f31ew6h">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-206" data-mp="12q40cnv2wgzu">
          <h2 className="font-display text-[clamp(2rem,5.5vw,3.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-207" data-mp="yqd3c2eyl4mv">
            Om LYKKEVÆRK
          </h2>
          <div data-id="element-208" data-mp="60mizbmqh6ib">
            <p className="text-[19px] leading-relaxed text-ink-soft md:text-xl" data-id="element-209" data-mp="6162uxvy24yz">
              LYKKEVÆRK er en mindre multiservicevirksomhed med fokus på ordentligt arbejde, god kommunikation
              og fleksible løsninger. Her har du direkte kontakt med den person, der udfører arbejdet, og der
              bliver lagt vægt på klare aftaler fra start til slut.
            </p>

            <ul className="mt-10 divide-y divide-line border-t border-line" data-id="element-210" data-mp="3jfsmcb7xrp1y">
              {values.map(value => <li key={value.title} className="py-5" data-id="element-211" data-mp="33a093bpr9kpk">
                  <h3 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-212" data-mp="337e33giijd9g">{value.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-213" data-mp="3cz1pv444k64l">{value.description}</p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}